console.log("Hi new av");
let pincodesJson;

// Add an event listener
document.addEventListener("name-of-event", function(e) {
  console.log(e.detail); // Prints "Example of an event"
});

// Create the event
const event = new CustomEvent('ajaxProduct:added', { "detail":'exp'});

// custom add to cart
function addToCartAjax(event,var_id, qty=1) {
  console.log(`pincode - ${pincode} var_id - ${var_id} and typeof ${typeof pincode}`)
  if(pincode){
      customATC(var_id, event, qty);
  }
  else{
    console.log('pincode is false ',event)
    let parentForm = event.target.parentNode;
    while (parentForm && parentForm.nodeName !== 'FORM') {
        parentForm = parentForm.parentNode;
    }
    // show the pincode modal
    showPincodeModal(var_id);
  }
}

// custom add to cart
function addToCartAjaxMod(event,purchase) {
  // Use event.currentTarget to get the element that triggered the event
  let element = event.currentTarget;
  let var_id = element.getAttribute('data-variant-id');
  let qty = element.getAttribute('data-variant-quantity');
  
  // Assuming pincode is declared in a higher scope or passed elsewhere
  console.log(`pincode - ${pincode} var_id - ${var_id} and typeof ${typeof pincode}`);
  
  if (pincode) {
    // Custom add to cart function
    customATC(var_id, event, qty, purchase, true);
  } else {
    console.log('pincode is false', event);
    
    // Finding the parent form
    let parentForm = element;
    while (parentForm && parentForm.nodeName !== 'FORM') {
        parentForm = parentForm.parentNode;
    }

    // Show the pincode modal (assuming this function exists)
    showPincodeModal(var_id);
  }
}

function buyNow(event){
  addToCartAjaxMod(event,true);
}

if(document.querySelector('.twpc-cont svg')){
  document.querySelector('.twpc-cont svg').addEventListener('click',() => {
    hidePincodeModal();
  });
}
if(document.querySelector('.twPincodeOveralay')){
  document.querySelector('.twPincodeOveralay').addEventListener('click',() => {
    hidePincodeModal();
  });
}

// custom atc
function customATC(var_id,event,qty,purchase,isModal=false){
  console.trace('customATC called from:'); // ← ADD THIS LINE
  console.log('Arguments:', {var_id, event, qty, purchase, isModal}); // ← ADD THIS
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: parseInt(qty),
      id: var_id
    },
    dataType: 'json',
    success: function (data){
      if(event != "gift") {
        document.dispatchEvent(event);
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
      if(purchase){
        window.location.href = '/checkout';
      } else {
        if(isModal === true){
          console.log('from modal');
          document.querySelector('#quick-add-modal').close();
        }
        // Avik cart update here
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
      }
    },
    error: function(err) {
      console.log(err);
    }
  });
}

// enable atc and checkout button
let enableBtn = () => {
  console.log('enableBtn called')
  document.querySelectorAll('.valid-pincode-checked').forEach((item) => {
    item.setAttribute('checked','');
  });
  pincode = true;
  if(document.querySelector('.product-section')){
    const pdpid = document.querySelector('.product-section').getAttribute('id');
    let pdpbtn = document.querySelector(`#${pdpid} [type="submit"]`);
    if(pdpbtn){
      // disabling the button
      pdpbtn.disabled = false;
    }
  }
  document.querySelectorAll('#CartDrawerForm [type="submit"]').forEach((item) => {
    item.disabled = false;
  })  
  document.querySelector('body').classList.remove('disableCheckout');
}

// disbale atc and checkout button
let disableBtn = (disableClass) => {
  console.log('disableBtn called')
  pincode = false;
  if(document.querySelector('.product-section')){
    const pdpid = document.querySelector('.product-section').getAttribute('id');
    // disabling the button
    document.querySelector(`#${pdpid} [type="submit"]`).disabled = true;
  }

  document.querySelectorAll('#CartDrawerForm [type="submit"]').forEach((item) => {
    item.disabled = true;
  })  

  document.querySelector('body').classList.add(disableClass);
}


// show the pincode modal
let showPincodeModal = (id) => {
  document.querySelector('.twpc-cont').style.display = 'flex';
  document.querySelector('.twPincodeOveralay').style.display = 'block';
  document.querySelector('.twpc-cont .pincheck').setAttribute('data-var-id',id);
}

// hide the pincode modal
let hidePincodeModal = () => {
  document.querySelector('.twpc-cont').style.display = 'none';
  document.querySelector('.twPincodeOveralay').style.display = 'none';
}

// setting the pincode message in differnet parts
let pincodeMsg = (pinMsg,editable) => {
  if(document.querySelector('#modal_opener')) document.querySelector('#modal_opener').textContent = pinMsg;
  if(document.querySelector('.nodelivery_msg')){
    document.querySelectorAll('.nodelivery_msg').forEach((item) => {
      item.textContent = pinMsg;
      if(editable===true){
        item.innerHTML = item.innerHTML + `
          <button class="edit-button" onclick="editPincode(event)">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="20px" height="20px" viewBox="0 0 494.936 494.936" xml:space="preserve">
              <g>
              	<g>
              		<path d="M389.844,182.85c-6.743,0-12.21,5.467-12.21,12.21v222.968c0,23.562-19.174,42.735-42.736,42.735H67.157    c-23.562,0-42.736-19.174-42.736-42.735V150.285c0-23.562,19.174-42.735,42.736-42.735h267.741c6.743,0,12.21-5.467,12.21-12.21    s-5.467-12.21-12.21-12.21H67.157C30.126,83.13,0,113.255,0,150.285v267.743c0,37.029,30.126,67.155,67.157,67.155h267.741    c37.03,0,67.156-30.126,67.156-67.155V195.061C402.054,188.318,396.587,182.85,389.844,182.85z"/>
              		<path d="M483.876,20.791c-14.72-14.72-38.669-14.714-53.377,0L221.352,229.944c-0.28,0.28-3.434,3.559-4.251,5.396l-28.963,65.069    c-2.057,4.619-1.056,10.027,2.521,13.6c2.337,2.336,5.461,3.576,8.639,3.576c1.675,0,3.362-0.346,4.96-1.057l65.07-28.963    c1.83-0.815,5.114-3.97,5.396-4.25L483.876,74.169c7.131-7.131,11.06-16.61,11.06-26.692    C494.936,37.396,491.007,27.915,483.876,20.791z M466.61,56.897L257.457,266.05c-0.035,0.036-0.055,0.078-0.089,0.107    l-33.989,15.131L238.51,247.3c0.03-0.036,0.071-0.055,0.107-0.09L447.765,38.058c5.038-5.039,13.819-5.033,18.846,0.005    c2.518,2.51,3.905,5.855,3.905,9.414C470.516,51.036,469.127,54.38,466.61,56.897z"/>
              	</g>
              </g>
            </svg>
          </button>
        `;
        console.log('edit button incoming');
      }
    });
  } 
  if(document.querySelector('#modal_opener')) document.querySelector('#modal_opener').classList.remove('d-none')
}
let pincodeMsgEmpty = () => {
  document.querySelector('#modal_opener').textContent = '';
  if(document.querySelector('.nodelivery_msg')){
    document.querySelectorAll('.nodelivery_msg').forEach((item) => {
      item.textContent = pinMsg;
    })
  } 
  document.querySelector('#modal_opener').classList.add('d-none')
}
let pincodeCheck = (userPincode,id) => {
  if (userPincode.length != 6){
    console.log('hello');
    pincodeMsg(`Please enter a valid pincode`)
    disableBtn('disableCheckout');
    return false;
  }
  console.log('pincodesJson ', pincodesJson);
  console.log('userPincode ', userPincode);
  let is_pincode_available = pincodesJson.filter(item => item.pincode == userPincode);
  sessionStorage.setItem("pincode", userPincode );
  // console.log('is_pincode_available ',is_pincode_available);
  if(is_pincode_available.length){
    enableBtn();
    if(is_pincode_available[0].sameDayDelivery){
      pincodeMsg(`Ready to deliver to Pincode: ${userPincode}.Next day delivery available.`,true)
    }
    else{
      pincodeMsg(`Ready to deliver to Pincode: ${userPincode}.`,true)
    }
    if(document.querySelector('.twpc-cont').style.display == 'flex'){
      setTimeout(() => {
        hidePincodeModal();
      }, "1000");
    }
    customATC(id, event, '1');
  }
  else{
    // pincode is not available
    pincodeMsg(`Coming soon at your doorstep! ${userPincode}`, true);
    disableBtn('disableCheckout');
    document.documentElement.style.setProperty('--disableText', `'Coming soon at your doorstep ! ${userPincode}'`);
  }
}

let pincodeOnloadCheck = () => {
  let sessionPincode = sessionStorage.getItem("pincode");
  if(sessionPincode) pincodeCheck(sessionPincode)
}

if(document.querySelector('.pincheck')){
  document.querySelectorAll('.pincheck').forEach((item)=>{
    item.addEventListener('click', (event) => {
      var target = event.target;
      var nearestParent = target.closest('.pc-top');
      var thisInputField = nearestParent.querySelector('#pincode_input');
      console.log(thisInputField);
      if(target.getAttribute('data-var-id') != 'undefined'){
        pincodeCheck(thisInputField.value,target.getAttribute('data-var-id'));
      } else {
        pincodeCheck(thisInputField.value);
      }
    });
  })
}

function editPincode(event) {
  let currentParent = event.target.closest('.pincode-wrapper');
  let inputField = currentParent.querySelector('.valid-pincode-checked')
  inputField.removeAttribute('checked');
}


// disabling all the buttons on load
disableBtn('disableCheckout');



function fetchPincodes(mode) {
  let pincodeJson_url_all = "https://cdn.shopify.com/s/files/1/0586/0999/1851/files/keventer_pincodesNew_c597720d-756d-437b-8433-23df7174562c.json?v=1747893963";
  let pincodeJson_url_metro = "https://cdn.shopify.com/s/files/1/0586/0999/1851/files/metroSubscribtionPincodes.json?v=1766559270";
  let pincodeJson_url;
  
  if(mode == "metro") {
    pincodeJson_url = pincodeJson_url_metro;
  } else {
    pincodeJson_url = pincodeJson_url_all
  }
  
  fetch(pincodeJson_url)
    .then(response => response.json())
    .then(data => {
        pincodesJson = data['pincodes'];
        pincodeOnloadCheck();
    })
    .catch(error => {
        console.error('Error fetching data:', error);
    });
}


//storing the list of pincodes

document.addEventListener('quickview:open', function(evt) {
  console.log('this is working');
  setTimeout(() => {
    console.log('quickview:open')
    disableBtn('disableCheckout')
    if(pincode == false) {
      pincodeOnloadCheck();
    }
  }, "1000");
});


document.querySelectorAll('button[data-add-to-cart].add-to-cart').forEach(button => {
  button.addEventListener('click', function() {
    console.log("Clicked for loader !!");
    
    setTimeout(() => {
      this.classList.remove('btn--loading');
    }, 600);
  });
});

